var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScraper = function SvgScraper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_2470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4775 2.53711C41.1876 2.53711 42.572 3.92317 42.5723 5.63184L42.5713 16.2451C42.5712 16.9622 42.3245 17.6205 41.915 18.1455C41.9831 18.1891 42.0282 18.2649 42.0283 18.3516V27.6123C42.0283 27.7478 41.9187 27.8574 41.7832 27.8574H38.6318C38.4965 27.8572 38.3867 27.7477 38.3867 27.6123V19.3408H37.627V29.125H44.9512V44.1318H44.1328V57.585H43.1406V66.0811C43.1404 66.5711 42.743 66.9695 42.2529 66.9697H39.2852V69.7158C39.2848 70.1348 38.9454 70.4753 38.5264 70.4756H33.5645C33.1416 70.4756 32.807 70.1314 32.8066 69.7158V66.9697H29.9473C29.4525 66.9697 29.0608 66.5668 29.0605 66.0811V57.585H27.9648V44.0889H27.0508V29.125H34.0898V19.3408H33.415V27.6123C33.415 27.7478 33.3054 27.8574 33.1699 27.8574H30.0186C29.8832 27.8572 29.7734 27.7477 29.7734 27.6123V18.3516C29.7735 18.2934 29.7942 18.2403 29.8281 18.1982C29.3939 17.6654 29.1329 16.9858 29.1328 16.2451V5.63184C29.133 3.92275 30.519 2.53716 32.2285 2.53711H39.4775Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14814_2470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.62 -41.249H-348.412V154.001H143.62V-41.249Z",
    stroke: "black",
    strokeWidth: 2.28042
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1074 5.72797C42.1074 4.37372 41.0104 3.27539 39.6555 3.27539H32.4064C31.0514 3.27539 29.9531 4.37372 29.9531 5.72797V16.3408C29.9531 17.695 31.0514 18.7934 32.4064 18.7934H39.6548C41.0097 18.7934 42.1067 17.695 42.1067 16.3408L42.1074 5.72797Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.2854,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7422 44.1848V29.7344H44.6151V44.228",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7422 44.1848V29.7344H44.6151V44.228",
    stroke: "black",
    strokeWidth: 1.02831
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6757 56.682C42.6757 56.5465 42.5658 56.4365 42.4303 56.4365H38.5501C38.4147 56.4365 38.3047 56.5465 38.3047 56.682V66.1768C38.3047 66.3123 38.4147 66.4223 38.5501 66.4223H42.4303C42.5658 66.4223 42.6757 66.3123 42.6757 66.1768V56.682Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.2854
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2519 56.682C34.2519 56.5465 34.1419 56.4365 34.0064 56.4365H30.125C29.9895 56.4365 29.8809 56.5465 29.8809 56.682V66.1768C29.8809 66.3123 29.9895 66.4223 30.125 66.4223H34.0064C34.1419 66.4223 34.2519 66.3123 34.2519 66.1768V56.682Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.2854
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9491 56.2845C38.9491 56.149 38.8391 56.0391 38.7036 56.0391H33.7422C33.6067 56.0391 33.498 56.1484 33.498 56.2845V69.8114C33.498 69.9468 33.6067 70.0568 33.7422 70.0568H38.7036C38.8391 70.0568 38.9491 69.9468 38.9491 69.8114V56.2845Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.02831
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6682 33.0405H28.7852V57.0388H43.6682V33.0405Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.2854
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4604 47.9229H29.9023V54.7131H42.4604V47.9229Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.642698
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6449 68.499H33.8418V69.6674H38.6449V68.499Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.03832
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1791 65.7302C36.5854 65.7302 36.9148 65.4008 36.9148 64.9945C36.9148 64.5882 36.5854 64.2588 36.1791 64.2588C35.7728 64.2588 35.4434 64.5882 35.4434 64.9945C35.4434 65.4008 35.7728 65.7302 36.1791 65.7302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1798 63.1351C36.8013 63.1351 37.305 62.6313 37.305 62.0099C37.305 61.3885 36.8013 60.8848 36.1798 60.8848C35.5584 60.8848 35.0547 61.3885 35.0547 62.0099C35.0547 62.6313 35.5584 63.1351 36.1798 63.1351Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3632 19.1348H34.709V33.0406H37.3632V19.1348Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.882851
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.593 18.4481C33.593 18.3126 33.4831 18.2026 33.3476 18.2026H30.1966C30.0611 18.2026 29.9512 18.3126 29.9512 18.4481V27.7086C29.9512 27.8441 30.0611 27.9541 30.1966 27.9541H33.3476C33.4831 27.9541 33.593 27.8441 33.593 27.7086V18.4481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2064 18.4481C42.2064 18.3126 42.0964 18.2026 41.9609 18.2026H38.8099C38.6744 18.2026 38.5645 18.3126 38.5645 18.4481V27.7086C38.5645 27.8441 38.6744 27.9541 38.8099 27.9541H41.9609C42.0964 27.9541 42.2064 27.8441 42.2064 27.7086V18.4481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9183 8.7793H30.2988V18.373H41.9183V8.7793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1413 10.958L32.1794 11.9968V17.1179H31.1387L31.1413 10.958Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.889 10.958L39.8496 11.9968V17.1179H40.8904L40.889 10.958Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4167 9.94824L31.6504 9.9502L32.6885 10.989H39.3694L40.4167 9.94824Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2773 3.54395V9.20184",
    stroke: "black",
    strokeWidth: 0.86886
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7246 3.54395V9.20184",
    stroke: "black",
    strokeWidth: 0.86886
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.082 6.26789L33.1735 4.48687C33.1735 4.48687 33.1735 3.22949 32.964 3.22949C32.7546 3.22949 31.1817 3.6484 31.1817 3.6484L30.3969 4.80106L30.082 6.26789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9221 6.26789L38.832 4.48687C38.832 4.48687 38.832 3.22949 39.0402 3.22949C39.2496 3.22949 40.8225 3.6484 40.8225 3.6484L41.6073 4.80106L41.9221 6.26789Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_2470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14814_2470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2545,
    height: 72,
    fill: "white",
    transform: "translate(24.9727 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScraper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "scraper.58ac7ea1a7a1a184e4b6e1d1689dbf43.svg";